/* eslint-disable max-lines-per-function */
import React from 'react';
import { Field, Form, ErrorMessage } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { states } from '../components/states';
import { Dropdown } from 'primereact/dropdown';
import Cidades from '../atom/Cidades.jsx';

export function FormCadastrarTv({ nomebotao }) {
    return (

        <Form style={{ fontWeight: 'bold' }} className="p-col-12 p-lg-12 p-sm-12">
                        
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12">
                
                    <div className="form-item-label">
                        <label htmlFor="nome">Nome da TV *</label>                               
                        <Field
                            as={InputText}
                            id="nome"
                            name="nome"
                            type="text"
                            size={30}
                            maxLength={60}
                        />
                        <ErrorMessage
                            component="span"
                            name="nome"
                            style={{ color: 'red' }}
                        />
                    </div>                            
                </div>
            </div>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-3" >
                    <div  className="form-item-label">
                        <label htmlFor="cep">CEP</label>
                    
                        <Field                                        
                            as={InputText}
                            id="cep"
                            name="cep"
                            type="string"
                            maxLength={8}
                        />
                            
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-3 p-field">
                    <div className="form-item-label">
                        <label htmlFor="estado">Estado</label>                    
                        <Field
                            as={Dropdown}
                            optionLabel="estado"
                            id="estado"
                            name="estado"
                            placeholder="Selecione o estado"
                            options={states}
                            type="text"
                            scrollHeight="150px"
                        />                            
                    </div>
                </div>     
                <Cidades/>
                <div className="p-col-12 p-md-12 p-lg-12 p-field" >                                    
                    <div className="form-item-label">
                        <label htmlFor="logradouro">Endereço</label>                                
                        <Field                                        
                            as={InputText}
                            id="logradouro"
                            name="logradouro"
                            type="text"
                            size={30}
                            maxLength={60}
                        />                                        
                    </div>                                    
                </div> 
                <div className="p-col-12 p-md-3">
                    <div  className="form-item-label">
                        <label htmlFor="numero">Numero</label>
                    
                        <Field                        
                            as={InputText}
                            id="numero"
                            name="numero"
                            type="number"
                            size={30}
                            maxLength={60}
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-5">
                    <div className="form-item-label">
                        <label htmlFor="bairro">Bairro</label>
                    
                        <Field                        
                            as={InputText}
                            id="bairro"
                            name="bairro"
                            type="text"
                            size={30}
                            maxLength={60}
                        />                            
                    </div>
                </div>
                <div className="p-col-12 p-md-4">
                    <div className="form-item-label">
                        <label htmlFor="complemento">Complemento</label>                    
                        <Field
                            as={InputText}
                            id="complemento"
                            name="complemento"
                            type="text"
                            size={30}
                            maxLength={60}
                        />
                    </div>
                </div>          
            </div>
          
            <div  className="p-grid p-fluid">
                <div className="p-col-6 p-md-3">
                    <Button
                        type="submit"
                        label={nomebotao}                            
                    />
                </div>
            </div>
        </Form>
    );
}